module.exports = __webpack_public_path__ + "img/node-network-thumb.0ecd07a9.jpg";